import { render, staticRenderFns } from "./asType.vue?vue&type=template&id=0cf26068&scoped=true&"
import script from "./asType.vue?vue&type=script&lang=ts&"
export * from "./asType.vue?vue&type=script&lang=ts&"
import style0 from "./asType.vue?vue&type=style&index=0&id=0cf26068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf26068",
  null
  
)

export default component.exports